module.exports = __webpack_public_path__ + "img/light_brand_allsan.ea8bd25b.gif";